import {
  getModelShortLabel,
  isAlgorithmicProducer,
  modelOfProducer
} from "../../../../utils/algorithmicProducer";

/** Display label for a producer value; algorithmic producers show their model's short name (the tooltip carries the full one). */
export function formatProducer(value: string): string {
  if (isAlgorithmicProducer(value)) {
    return getModelShortLabel(modelOfProducer(value));
  }
  switch (value) {
    case "user":
      return "User";
    case "budget":
      return "Budget";
    case "ds":
      return "Forecast";
    default:
      // Reference cubes carry a display label already (a version tag or
      // ``owner:version``).
      return value;
  }
}
